// extracted by mini-css-extract-plugin
export var cartContainer = "_pt-4";
export var gray = "_pt-1";
export var itemContainer = "_pt-2";
export var itemDetails = "_pt-3";
export var strong = "_pt-0";